import * as React from 'react'
import { Link } from 'gatsby'
// import { useStaticQuery, graphql } from 'gatsby'

// Import from a CSS file in your src

const PrivacyPolicyLink = () => {
  //   const data = useStaticQuery(graphql`
  //   query {
  //       datoCmsMarketingSitePdf(pdfId: {eq: 12}) {
  //           pdfId
  //           pdfLink {
  //             url
  //           }
  //           pdfName
  //         }
  //   }
  // `)
  // const pdf = data.datoCmsMarketingSitePdf;
  return (
    // <a href={ pdf.pdfLink.url } >Privacy Policy</a>
    <Link href="/Privacy_Policy">
        Privacy Policy
    </Link>
  )
}

export default PrivacyPolicyLink

